import { withInstall } from '@vuemap/vue-amap-util'
import Buildings from './Buildings.vue'

export const ElAmapLayerBuildings = withInstall(Buildings)
export default ElAmapLayerBuildings
